import { themeConfig } from './theme-config';

/**
 * Prefixes a given class name with the theme's class prefix.
 *
 * This function takes a class name string and returns a new string with the theme's
 * class prefix appended with double underscores, following the format:
 * `{themeConfig.classesPrefix}__{className}`.
 *
 * @param className - The class name to prefix
 * @returns The prefixed class name string
 *
 * @example
 * // If themeConfig.classesPrefix is "theme"
 * createClasses('button'); // returns "theme__button"
 */
export function createClasses(className: string): string {
    return `${themeConfig.classesPrefix}__${className}`;
}
